import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { OverdueView } from 'src/sections/cheque-factoring/view';

export default function FactoringOverdueSettlementsPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Overdue Settlements</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_FACTORING_OVERDUE,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <OverdueView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
